/**
 * author       : zwl
 * createTime   : 2018/6/28 下午5:08
 * description  :
 */
import api from 'util/axios'

export function getAppCategory (appCategoryId) {
  return api({
    method: 'get',
    url: '/appCategory/app/' + appCategoryId
  })
}

export function createAppCategory (params) {
  return api({
    method: 'post',
    url: '/appCategory/' + params.appId,
    data: params
  })
}

export function updateAppCategory (appCategoryId, params) {
  return api({
    method: 'put',
    url: '/appCategory/' + appCategoryId + '/' + params.appId,
    data: params
  })
}

export function deleteAppCategory (appCategoryId, appId) {
  return api({
    method: 'delete',
    url: '/appCategory/' + appCategoryId + '/' + appId
  })
}
